var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-headerlogo"}},[(this.picture)?_c('v-img',{staticClass:"float-left",attrs:{"src":this.picture,"max-height":"50","max-width":"220"}}):_c('v-img',{staticClass:"float-left",attrs:{"src":`${_vm.publicPath}images/company_name.png`,"max-height":"50","max-width":"220"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }